<template>
  <div class="animated fadeIn">
    <global-table :table-data="employeeMobileDevice" :loading="loadingParam" :per-page="10" :bordered="true"
      :table-detail="tableDetail" :hover="true" :striped="false" :fields="fields" :row-edit="employeeSourceSalaryForm"
      :redirect-detail="false" :show-add-button="false" :remove-button="true" :edit-button="false"
      caption="<i class='fa fa-align-justify'></i> Sumber Gaji Karyawan" addButton="Tambah Sumber"
      @removeForm="removeForm"></global-table>

  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import _interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
export default {
  name: "employee-mobile",
  components: { loading, ModelSelect, MultiSelect, loading, globalTable },
  data() {
    return {
      employeeSourceSalaryForm: _interfaces.employee_source_salary,
      employeeMobileDevice: [],
      employee_id: '',
      isEdit: false,
      fields: [
        { key: "device_id", label: "Device ID", class: "width-250" },
        {
          key: "device_agent",
          label: "Device Agent",
          class: "width-250",
          sortable: true,
        },
        {
          key: "app_version",
          label: "Versi App",
          class: "width-250",
          sortable: true,
        },
        {
          key: "os_version",
          label: "Versi OS",
          class: "width-250",
          sortable: true,
        },
        {
          key: "date_inserted",
          label: "Regestered Date",
          class: "width-100",
          sortable: false,
        },
        { key: "action", class: "width-50 text-center" },
      ],
      loadingSubmitModal: false,
    };
  },
  props: {
    isDisable: {
      type: Boolean,
      default: true,
    },
    nik: {
      type: String,
      default: "",
    },
    loadingParam: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
    tableDetail: {
      type: Boolean,
      default: true,
    },
    listCompany: {
      type: [Array],
      default: () => [],
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    employeeSourceSalaryForm: {
      nik: {},
      company: { required },
      salary: { required },
    },
  },
  methods: {
    init: function () {
      this.resetForm();
      let route = this.$route.path.split("/");
      this.employee_id = route[4];
      this.getEmployeeSourceSalary(route[4]);
    },

    getEmployeeSourceSalary: function (id) {
      this.axios
        .get("web/employee/mobile-device/" + id)
        .then((response) => {
          this.employeeMobileDevice = response.data.data;
        })
        .catch((error) => { })
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (e) {
      this.isEdit = true;
      this.employeeSourceSalaryForm = e;
    },
    resetForm: function () {
      for (var a in _interfaces.employee_source_salary) {
        _interfaces.employee_source_salary[a] = null;
      }
      this.employeeSourceSalaryForm = _interfaces.employee_source_salary;
    },
    removeForm: function (a) {
      if (confirm("Apakah anda ingin menghapus perangkat ini dari akun ?")) {
        this.loadingSubmitModal = true;
        this.axios
          .delete("web/employee/mobile-device/" + a.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Hapus Perangkat Berhasil",
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: "Hapus Perangkat Gagal",
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            this.cancelAdd();
            this.init();
          });
      }
      console.log(a);
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah informasi sumber gaji ?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put(
              "web/employee/edit-source-salary/",
              this.employeeSourceSalaryForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Sumber Gaji Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Ubah Sumber Gaji Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan informasi sumber gaji ?")) {
          this.loadingSubmitModal = true;
          this.employeeSourceSalaryForm.employee_id = this.employee_id;
          this.axios
            .post(
              "web/employee/add-source-salary/",
              this.employeeSourceSalaryForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Sumber Gaji Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Sumber Gaji Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
